import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Input } from 'semantic-ui-react'
import { MilkMoneyQuery } from '~/QueryHooks/MilkMoneyQuery'
import Layout from '~/components/Layout'
import TableComponent from '~/components/TableComponent'
import i18n from '~/components/i18n'
import { useDebounce } from 'use-lodash-debounce';
import MSWSetup from './MSWSetup'

const getTableColumnHeaders = () => [
  {
    name: i18n.t('Supplier No.'),
    key: 'supplierNo'
  },
  {
    name: i18n.t('Company name'),
    key: 'companyName'
  },
  {
    name: i18n.t('MSW'),
    key: 'truckNumber'
  },
  {
    name: i18n.t('Tour'),
    key: 'tourNumber'
  },
  {
    name: i18n.t('Order'),
    key: 'order'
  }
]

const TourPlanning: React.FC = () => {
  const { t } = useTranslation()
  const [search, setSearch] = useState('');
  const debouncedSearchValue = useDebounce(search, 300);
  const [dataFiltered, setDataFiltered] = useState({
    page: 0,
    rows: 20,
    search: ''
  })

  const {
    data: tourPlanningData,
    isLoading: isBusy,
    refetch: fetchData,
    isFetching: isFetchingData
  } = MilkMoneyQuery.getMilkMoneyTourPlanning({ ...dataFiltered, page: dataFiltered.page === 0 ? dataFiltered.page : dataFiltered.page - 1 })

  useEffect(() => {
    fetchData()
  }, [dataFiltered])

  useEffect(() => {
    setDataFiltered({ ...dataFiltered, search: debouncedSearchValue, page: 0 });
  }, [debouncedSearchValue]);

  function renderTable() {
    return <TableComponent
      isFetchingData={isFetchingData}
      animated
      tableColumnHeaders={getTableColumnHeaders()}
      dataFiltered={dataFiltered}
      handleChangeDataFiltered={(data) => setDataFiltered(data)}
      rows={rows}
      total={filtered}
    />
  }

  function renderFilters() {
    return (
      <Input
        icon={{ name: 'search', circular: true, link: true }}
        placeholder={t('Search...')}
        value={search}
        onChange={(e, data) => setSearch(data.value)}
      />
    );
  }

  function renderActions() {
    return <MSWSetup/>
  }

  const { filtered, rows } = tourPlanningData ? tourPlanningData : { filtered: 0, rows: [] };

  return <Layout
    segmented
    isBusy={isBusy}
    title={t('Tour planning')}
    filters={renderFilters()}
    actions={renderActions()}
  >
    {renderTable()}
  </Layout>
}
export default TourPlanning